export default __webpack_public_path__ + "static/sOliverCase-RegularWeb-4422d55f22b6b26399af772af071e47e.woff";